.wrapper {
  position: relative;
  width: 100%;
}

.tabsContainer {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: thin;
  scrollbar-color: #d0d0d0 transparent;
  -webkit-overflow-scrolling: touch;
}

.arrow {
  position: absolute;
  top: calc(50% - 4px);
  transform: translateY(-50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e0d8d0;
  background: #fffdf7;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #505050;
  z-index: 2;
  padding: 0;
  transition:
    opacity 0.2s ease,
    transform 0.2s ease,
    background-color 0.2s ease;
}

.arrow svg {
  width: 22px;
  height: 22px;
}

.arrow:hover {
  background: #f5f3ef;
}

.arrow:focus-visible {
  outline: 2px solid #505050;
  outline-offset: 2px;
}

.arrowLeft {
  left: 4px;
}

.arrowRight {
  right: 4px;
}

.arrowHidden {
  opacity: 0;
  pointer-events: none;
  transform: translateY(-50%) scale(0.8);
}

.tabsContainer::-webkit-scrollbar {
  height: 4px;
}

.tabsContainer::-webkit-scrollbar-thumb {
  background: #d0d0d0;
  border-radius: 4px;
}

.tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  cursor: pointer;
  background: none;
  border: 2px solid transparent;
  border-radius: 20px;
  padding: 0;
  transition: border-color 0.2s ease, opacity 0.2s ease;
}

.tab:hover {
  border-color: #c0c0c0;
}

.tabActive {
  border-color: #505050;
}

.tabActive:hover {
  border-color: #505050;
}

.imageWrap {
  width: 160px;
  height: 120px;
  border-radius: 18px;
  overflow: hidden;
  background: #f5f3ef;
}

.tabImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.allIcon {
  width: 160px;
  height: 120px;
  border-radius: 18px;
  background: linear-gradient(135deg, #f5f3ef 0%, #e8e4dd 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  color: #707070;
}

.tabLabel {
  font-size: 14px;
  font-weight: 300;
  color: #505050;
  white-space: nowrap;
  padding: 0 8px 8px;
}

.tabActive .tabLabel {
  font-weight: 500;
}

@media (max-width: 768px) {
  .tabsContainer {
    gap: 10px;
  }

  .imageWrap,
  .allIcon {
    width: 120px;
    height: 90px;
  }

  .tabLabel {
    font-size: 12px;
  }

  .arrow {
    display: flex;
  }
}
